import classes from "./Greetings.module.css"
const Greetings=()=>{
    return(
        <div className={classes.container} id='about-section'>
            
            <p>'Step into a realm of digital wonders, where innovation takes shape and web experiences come alive. Get ready to embark on an extraordinary journey through my portfolio.'</p>
        </div>
    )
}
export default Greetings